
import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import Bkrl from './Bklr.vue'
import VbitStatusBanner from '@/components/banner/vbitStatus.vue'

@Component({
    components: { AppToolbar, Bkrl, VbitStatusBanner },
})
export default class BkrlIndex extends Mixins<MixinInterface>() {
    key = 0

    get lang() {
        return this.formatLangTo6391(this.userLanguage).toUpperCase()
    }

    @Watch('lang')
    updateView() {
        this.key += 1
    }
}
